import {connect} from "react-redux";
import {DispatchProps, Home, InnerProps, StateProps} from "../components/Home";
import {RootState, ThunkDispatch} from "../types";
import {Routes} from "../utils/router";
import {doResendEmail} from "../actions/thunks/users";

function mapStateToProps({i18n}: RootState): StateProps {
    return {
        locale: i18n.locale,
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
    return {
        onGoToStore: () => window.open(Routes.STORE, "_blank"),
        onResendEmail: () => dispatch(doResendEmail()),
    };
}

export default connect<StateProps, DispatchProps, InnerProps, RootState>(mapStateToProps, mapDispatchToProps)(Home);